module.exports = __webpack_public_path__ + "img/search_entry.14c97885.jpg";